import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import NavigatorMain from '../NavigatorMain';
// import Util from '../util.js';


import { Picker, List, WhiteSpace ,Toast} from 'antd-mobile/lib';







class TaxSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title:''
    };
    this.flag=false;
  }
  componentWillMount(){
      document.getElementsByTagName('title')[0].innerHTML = "实名认证";
      this.setState({
        title:'实名认证'
      })
  }
  next(){
    //登录成功回调
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    if(route) {
      // hashHistory.go(route - window.history.length);
      hashHistory.go(-7);
    }
    this.flag=true
  }
  componentWillUnmount(){
    if (this.flag) {
      this.flag=false
      let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
      if(callback) {
        callback();
      }
    }
  }

  render(){

    console.log(this.props.location)

    return (
        <div className="container" >
          <NavigatorMain>
          <div className="header black">
            <div><span className=""></span></div>
            <div>{this.state.title}</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div className='content'>
          <div style={{display: "-webkit-flex",WebkitAlignItems: "center",fontSize:'0.30rem',flexFlow:'column',background:'#fff',padding:'1rem 13px 1rem 13px',}}>
            <div style={{textAlign:'center'}}>
             <img src={require('../../img/successO.png')} style={{width:'1.24rem',height:'1.24rem'}}/>
             <p style={{marginTop:'0.2rem'}}>{`${this.state.title}成功!`}</p>
           </div>
          </div>

          <div style={{
            display: "-webkit-flex",
            marginTop: 15,
            height: 40,
            backgroundColor: "#fa063a",
            WebkitJustifyContent: "center",
            WebkitAlignItems: "center",
            borderRadius: 30,
            marginLeft: 13,
            marginRight: 13,
            marginBottom: 15
          }}
          >
          <div style={{color: "#fff", fontSize: "0.3rem"}}  onClick={()=>this.next()}>返回我的资产</div>

        </div>
        </div>
      </div>
    );
  }
}




export default TaxSuccess



// WEBPACK FOOTER //
// ./src/components/fundDetail/TaxSuccess.js